/**
 * Coast Range article reading aids: progress bar, TOC highlight, mobile deal bar.
 */
(function () {
  'use strict';

  function initProgress(root) {
    var wrap = document.querySelector('.coast-range-article-progress');
    var bar = document.querySelector('[data-crc-progress-bar]');
    var content = root.querySelector('.article-template__content');
    if (!bar || !content) return;

    function update() {
      var rect = content.getBoundingClientRect();
      var total = content.offsetHeight - window.innerHeight;
      var scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
      var pct = total > 0 ? (scrolled / total) * 100 : 0;
      bar.style.width = pct.toFixed(2) + '%';
      if (wrap) wrap.setAttribute('aria-valuenow', String(Math.round(pct)));
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function slugify(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '')
      .slice(0, 64);
  }

  function initToc(root) {
    var content = root.querySelector('.article-template__content');
    var lists = root.querySelectorAll('[data-crc-toc-list]');
    if (!content || !lists.length) return;

    var headings = content.querySelectorAll('h2');
    if (!headings.length) {
      lists.forEach(function (list) {
        var nav = list.closest('[data-crc-toc]');
        if (nav) nav.hidden = true;
      });
      return;
    }

    var items = [];
    headings.forEach(function (h, i) {
      if (!h.id) {
        h.id = 'crc-section-' + (slugify(h.textContent) || i);
      }
      items.push({ id: h.id, text: h.textContent.trim(), el: h });
    });

    lists.forEach(function (list) {
      list.innerHTML = '';
      items.forEach(function (item) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + item.id;
        a.textContent = item.text;
        a.className = 'coast-range-article-toc__link';
        li.appendChild(a);
        list.appendChild(li);
      });
    });

    function highlight() {
      var current = items[0] && items[0].id;
      for (var i = 0; i < items.length; i++) {
        var top = items[i].el.getBoundingClientRect().top;
        if (top <= 120) current = items[i].id;
      }
      lists.forEach(function (list) {
        list.querySelectorAll('a').forEach(function (a) {
          if (a.getAttribute('href') === '#' + current) {
            a.setAttribute('aria-current', 'location');
          } else {
            a.removeAttribute('aria-current');
          }
        });
      });
    }

    window.addEventListener('scroll', highlight, { passive: true });
    highlight();
  }

  function initMobileDealBar(root) {
    var bar = document.querySelector('[data-crc-deal-mobile-bar]');
    var primaryCta = root.querySelector('[data-crc-deal-cta="primary"]');
    if (!bar || !primaryCta) return;

    function update() {
      if (window.matchMedia('(min-width: 990px)').matches) {
        bar.classList.remove('is-visible');
        root.classList.remove('has-mobile-deal-bar');
        return;
      }
      var rect = primaryCta.getBoundingClientRect();
      var offscreen = rect.bottom < 0 || rect.top > window.innerHeight;
      bar.classList.toggle('is-visible', offscreen);
      root.classList.toggle('has-mobile-deal-bar', offscreen);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function initCountdown(root) {
    var nodes = root.querySelectorAll('[data-crc-ends-at]');
    nodes.forEach(function (node) {
      var endsAt = node.getAttribute('data-crc-ends-at');
      if (!endsAt) return;
      var end = Date.parse(endsAt);
      if (isNaN(end)) return;

      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          node.textContent = 'Ended';
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        node.textContent = 'Ends in: ' + d + 'd ' + String(h).padStart(2, '0') + 'h ' + String(m).padStart(2, '0') + 'm';
      }

      tick();
      setInterval(tick, 60000);
    });
  }

  function init() {
    var root = document.querySelector('.coast-range-article');
    if (!root) return;
    initProgress(root);
    initToc(root);
    initMobileDealBar(root);
    initCountdown(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
